export const SdeWorkbookRoutes = {
  generateWorkbook: "/v1/tax/recasting/income/sde-workbook",
} as const;
